/**
 * Burton Forms — address model. Layer 1 (no DOM).
 *
 * Per-country POSTAL and PHONE patterns, keyed by lowercased ISO code, plus `deriveRegion()`.
 */
window.BAO = window.BAO || {}
window.BAO.Forms = window.BAO.Forms || {}

// Per-COUNTRY config, keyed by lowercased ISO country code. Read by the `postalCode` and `phone`
// rules; a country with no entry validates permissively. Patterns are the authoritative Burton
// formats ported from the old SFCC config
window.BAO.Forms.address = window.BAO.Forms.address || {
  us: {
    postal: { pattern: /^\d{5}(-\d{4})?$/ },
    phone: { pattern: null },
  },
  ca: {
    postal: { pattern: /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/ },
    phone: { pattern: null },
  },
  jp: {
    postal: { pattern: /^\d{3}-?\d{4}$/ },
    phone: { pattern: null },
  },
  at: { postal: { pattern: /^\d{4}$/ }, phone: { pattern: null } },
  be: { postal: { pattern: /^\d{4}$/ }, phone: { pattern: null } },
  bg: { postal: { pattern: /^\d{4}$/ }, phone: { pattern: null } },
  hr: { postal: { pattern: /^\d{5}$/ }, phone: { pattern: null } },
  cz: { postal: { pattern: /^\d{3}\s?\d{2}$/ }, phone: { pattern: null } },
  dk: { postal: { pattern: /^\d{4}$/ }, phone: { pattern: null } },
  ee: { postal: { pattern: /^\d{5}$/ }, phone: { pattern: null } },
  fi: { postal: { pattern: /^\d{5}$/ }, phone: { pattern: null } },
  fr: { postal: { pattern: /^\d{5}$/ }, phone: { pattern: null } },
  de: { postal: { pattern: /^\d{5}$/ }, phone: { pattern: null } },
  gr: { postal: { pattern: /^\d{3}\s?\d{2}$/ }, phone: { pattern: null } },
  hu: { postal: { pattern: /^\d{4}$/ }, phone: { pattern: null } },
  ie: {
    postal: {
      pattern:
        /^[AC-FHKNPRTV-Y]{1}[0-9A-Z]{1}([0-9W]{1})?([ -]?[0-9AC-FHKNPRTV-Y]{4})?$/,
    },
    phone: { pattern: null },
  },
  it: { postal: { pattern: /^\d{5}$/ }, phone: { pattern: null } },
  lv: {
    postal: { pattern: /^([a-zA-Z]{2})?-?\d{4}$/ },
    phone: { pattern: null },
  },
  lt: {
    postal: { pattern: /^([a-zA-Z]{2})?-?\d{5}$/ },
    phone: { pattern: null },
  },
  lu: { postal: { pattern: /^\d{4}$/ }, phone: { pattern: null } },
  nl: {
    postal: { pattern: /^\s*?\d{4}\s?[a-zA-Z]{2}\s*?$/ },
    phone: { pattern: null },
  },
  no: { postal: { pattern: /^\d{4}$/ }, phone: { pattern: null } },
  pl: { postal: { pattern: /^\d{2}-?\d{3}$/ }, phone: { pattern: null } },
  pt: { postal: { pattern: /^\d{4}(-\d{3})?$/ }, phone: { pattern: null } },
  ro: { postal: { pattern: /^\d{5,6}$/ }, phone: { pattern: null } },
  sk: { postal: { pattern: /^\d{3}\s?\d{2}$/ }, phone: { pattern: null } },
  si: {
    postal: { pattern: /^([a-zA-Z]{2})?-?\d{4}$/ },
    phone: { pattern: null },
  },
  es: { postal: { pattern: /^\d{5}$/ }, phone: { pattern: null } },
  se: { postal: { pattern: /^\d{3} ?\d{2}$/ }, phone: { pattern: null } },
  ch: { postal: { pattern: /^\d{4}$/ }, phone: { pattern: null } },
  gb: {
    postal: {
      pattern:
        /^([A-PR-UWYZa-pr-uwyz]([0-9]{1,2}|([A-HK-Ya-hk-y][0-9]|[A-HK-Ya-hk-y][0-9]([0-9]|[ABEHMNPRV-Yabehmnprv-y]))|[0-9][A-HJKS-UWa-hjks-uw])[ ]{0,1}[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}|([Gg][Ii][Rr][ ]0[Aa][Aa])|([Ss][Aa][Nn][ ]{0,1}[Tt][Aa]1)|([Bb][Ff][Pp][Oo][ ]{0,1}([Cc]\/[Oo][ ])?[0-9]{1,4})|(([Aa][Ss][Cc][Nn]|[Bb][Bb][Nn][Dd]|[BFSbfs][Ii][Qq][Qq]|[Pp][Cc][Rr][Nn]|[Ss][Tt][Hh][Ll]|[Tt][Dd][Cc][Uu]|[Tt][Kk][Cc][Aa])[ ]{0,1}1[Zz][Zz]))$/,
    },
    phone: { pattern: null },
  },
}

/**
 * Map an ISO country code to its region bucket. Only US/CA (→ na) and JP (→ jp) are special; every
 * other country is treated as EU. Empty → null.
 *
 * @param {string} country  ISO country code (any case)
 * @returns {string|null}
 */
window.BAO.Forms.deriveRegion =
  window.BAO.Forms.deriveRegion ||
  function deriveRegion (country) {
    if (!country) return null

    const code = String(country).toUpperCase()

    if (code === 'US' || code === 'CA') return 'na'
    if (code === 'JP') return 'jp'

    return 'eu'
  }
